<div *ngIf="isLoggedIn" class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
  <div class="sidebar-header">
    <a href="#" class="sidebar-logo">
      <img class="" *ngIf="!isSidebarCollapsed" width="125px" height="48px" src='assets/eliwell_se.svg' />
    </a>
    
      <qds-button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
              (click)="sidebarToggle.emit()" size="large" importance="subdued" icon-only="true"
              icon-name='chevron-right-edge' iconLibrary="default">
      </qds-button>
    
    <!-- [icon-name]="isSidebarCollapsed ? 'chevron-left-edge' : 'chevron-right-edge'" -->
     <!-- [ngClass]="{'rotated': isSidebarCollapsed}" -->

    <!-- <div style="width: 100%; height: 100%; transform: rotate(180deg); transform-origin: top left; border-radius: 4px; justify-content: center; align-items: center; display: inline-flex">
      <div style="width: 16px; height: 16px; position: relative; overflow: hidden">
        <div style="width: 11.27px; height: 16px; left: 2.37px; top: 0px; position: absolute; background: var(--control-text-standard, white)"></div>
      </div>
      <qds-button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
              (click)="sidebarToggle.emit()" size="large" importance="subdued"
              icon-name='chevron-right-edge'>
      </qds-button>
    </div> -->


  </div>
  <div class="sidebar-menu">
    <div data-collapsed="false" data-divider="false" data-kicker="false" data-last="false" data-size="large"
      class="qds-nav-subsection">

      <div 
        style="width: 100%; height: 100%; background: var(--qds-theme-navigation-background); flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <!-- <qds-nav-list-item icon-name="dots-9-grid" importance="standard" text="Dashboard" subtitle="false" focus="false" class="menu " size="large">Dashboard</qds-nav-list-item> -->
        <!-- <qds-nav-list-item icon-name="breaker" importance="standard" text="My Device" subtitle="false" focus="false" class="menu selectedMenu" size="large">My Device</qds-nav-list-item>
        <qds-nav-list-item icon-name="bell-waves" importance="standard" text="Alarm" subtitle="false" focus="false" class="menu" size="large">Alarm</qds-nav-list-item>
        <qds-nav-list-item icon-name="gear-writing-board" importance="standard" text="HACCP Report" subtitle="false" focus="false" class="menu " size="large" [routerLink]="['/haccpreports']" routerLinkActive="selectedMenu">HACCP Report</qds-nav-list-item>
        <qds-nav-list-item icon-name="arrows-facing-right-left" importance="standard" text="Subscription" subtitle="false" focus="false" class="menu " size="large">Subsection</qds-nav-list-item>
        <qds-nav-list-item icon-name="gear" importance="standard" text="Manage" subtitle="false" focus="false" class="menu" size="large">Manage</qds-nav-list-item> -->


        <qds-nav-list-item icon-name="breaker" importance="standard" text="My Device" subtitle="false" focus="false"
                  class="menu" size="large" [routerLink]="['/dashboard']" routerLinkActive="selectedMenu">
                  My Device
                </qds-nav-list-item>
        <!-- <qds-nav-list-item icon-name="bell-waves" importance="standard" text="Alarm" subtitle="false" focus="false"
          class="menu" size="large" [routerLink]="['/alarm']" routerLinkActive="selectedMenu">
          Alarm
        </qds-nav-list-item>
        <qds-nav-list-item icon-name="gear-writing-board" importance="standard" text="HACCP Report" subtitle="false"
          focus="false" class="menu" size="large" [routerLink]="['/haccpreports']" routerLinkActive="selectedMenu">
          HACCP Report
        </qds-nav-list-item>
        <qds-nav-list-item icon-name="arrows-facing-right-left" importance="standard" text="Subscription"
          subtitle="false" focus="false" class="menu" size="large" [routerLink]="['/subscription']"
          routerLinkActive="selectedMenu">
          Subsection
        </qds-nav-list-item> -->
        <qds-nav-list-item icon-name="gear" importance="standard" text="System" subtitle="false" focus="false"
          class="menu" size="large" [routerLink]="['/system']" routerLinkActive="selectedMenu">
          
        </qds-nav-list-item>

        <!-- <qds-button icon-name="gear" text="System" size="large" importance="subdued" ></qds-button> -->

      </div>

    </div>
  </div>

</div>
